"use client";

import { useEffect } from "react";
import { usePathname, useSearchParams } from "next/navigation";
import { progress } from "@/services/nprogress";

const TopProgressBar = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const key = `${pathname}?${searchParams?.toString() || ""}`;

  useEffect(() => {
    const start = () => progress.intentStart();

    const onClickCapture = (e: MouseEvent) => {
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1)
        return;

      const el = e.target as Element | null;
      const a = el?.closest("a") as HTMLAnchorElement | null;
      if (!a) return;

      const href = a.getAttribute("href") || "";
      if (!href || href.startsWith("#")) return;
      if (a.target === "_blank" || a.hasAttribute("download")) return;

      try {
        const url = new URL(href, window.location.href);
        if (url.origin !== window.location.origin) return;

        const samePathAndSearch =
          url.pathname === location.pathname && url.search === location.search;
        if (samePathAndSearch) return;

        start();
      } catch (error) {
        console.warn("Invalid URL encountered:", error);
      }
    };

    const onPopState = () => start();

    window.addEventListener("click", onClickCapture, true);
    window.addEventListener("popstate", onPopState);

    return () => {
      window.removeEventListener("click", onClickCapture, true);
      window.removeEventListener("popstate", onPopState);
    };
  }, []);

  // Troca de URL detectada → finaliza com “soft finish” (fallback).
  // Se você tiver `app/loading.tsx`, chame `progress.forceDone()` no unmount dele
  // para encerrar a barra exatamente quando o carregamento terminar.
  useEffect(() => {
    progress.softFinish();
  }, [key]);

  return null;
};

export default TopProgressBar;
